import cn from 'classnames';

import type {LayoutProps} from '.';

import styles from './styles.module.scss';

type LayoutUi = LayoutProps['ui'];

export const getContainerClassName = (ui: LayoutUi): string => {
  return cn(styles.layout, {
    [styles.layout__modWhiteBackground]: ui?.fullScreenStepWrapper === true,
    [styles.layout__modTopAndNoBackground]: ui?.fullScreenStepWrapper === true,
  });
};

export const getStepClassName = (ui: LayoutUi): string => {
  return cn(styles.layout__step, {
    [styles.layout__step__modAlignTop]: ui?.fullScreenStepWrapper === true,
  });
};

export const getWrapperClassName = (
  currentStep: string,
  ui: LayoutUi,
): string => {
  return cn(styles.stepWrapper, {
    [styles.stepWrapper__modAnimationStep]: currentStep === 'animation',
    [styles.stepWrapper__modVerticalStretch]: currentStep === 'about',
    [styles.stepWrapper__modNoSpacing]: ui?.fullScreenStepWrapper === true,
  });
};

export const getWrapperStepClassName = (ui: LayoutUi): string => {
  return cn(styles.stepWrapper__step, {
    [styles.stepWrapper__step__modFitContentMobile]:
      ui?.fullScreenStepWrapper === true,
  });
};

export const getControlsClassName = (
  isContinueButtonVisible: boolean,
  ui: LayoutUi,
): string => {
  return cn(styles.stepWrapper__controls, {
    [styles.stepWrapper__controls__modSingleButton]: isContinueButtonVisible,
    [styles.stepWrapper__controls__modColumnMobile]: !!ui?.inlineBackMobile,
  });
};

export const getMobileBackClassName = (ui: LayoutUi): string => {
  return cn(styles.stepWrapper__controls_mobileBack, {
    [styles.stepWrapper__controls_mobileBack__modHidden]:
      !!ui?.inlineBackMobile,
  });
};

export const getDesktopBackClassName = (ui: LayoutUi): string => {
  return cn(styles.stepWrapper__controls_desktopBack, {
    [styles.stepWrapper__controls_desktopBack__modInlineMobile]:
      !!ui?.inlineBackMobile,
  });
};

export const getDesktopBackInlineClassName = (ui: LayoutUi): string => {
  return cn(styles.stepWrapper__controls_desktopBackInline, {
    [styles.stepWrapper__controls_desktopBackInline__modInlineMobile]:
      !!ui?.inlineBackMobile,
  });
};

export const getFooterSecureClassName = (currentStep: string): string => {
  return cn(styles.stepWrapper__footerMobile_secureInformation, {
    [styles.stepWrapper__footerMobile_secureInformation_modAbout]:
      currentStep === 'about',
  });
};

export const getContinueBtnLabel = (isAboutStep: boolean): string => {
  return isAboutStep ? 'See Advisor Matches' : 'Continue';
};
